"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Shape_1 = require("./Shape");
var image_1 = require("../image");
var CircleShape_1 = require("./CircleShape");
var utils_1 = require("../utils");
var TextShape = /** @class */ (function (_super) {
    __extends(TextShape, _super);
    function TextShape(text, size, pos) {
        if (size === void 0) { size = 12; }
        if (pos === void 0) { pos = [0, 0]; }
        var _this = _super.call(this) || this;
        _this.text = text;
        _this.size = size;
        _this.pos = pos;
        _this.render = function (ctx) {
            ctx.save();
            ctx.textAlign = 'start';
            ctx.textBaseline = 'top';
            ctx.font = _this.size + 'px FZKaTong-M19S';
            var width = ctx.measureText(_this.text).width;
            ctx.fillText(_this.text, _this.pos[0], _this.pos[1]);
            var idata = ctx.getImageData(_this.pos[0], _this.pos[1], width, _this.size);
            console.log(idata);
            var ps = utils_1.chunk(20, image_1.getPointsFromImageData(idata)).map(function (r) { return r[0]; });
            ctx.clearRect(_this.pos[0], _this.pos[1], width, _this.size);
            ps.map(function (p) {
                var c = new CircleShape_1.CircleShape([utils_1.index2pos(p, idata.width), 2]);
                return c;
            }).forEach(function (s) {
                ctx.save();
                var color = Math.floor(Math.random() * 256);
                var color1 = Math.floor(Math.random() * 80);
                var color2 = Math.floor(Math.random() * 25);
                ctx.strokeStyle = 'rgba(' + color + ',' + color1 + ',' + color2 + ')';
                s.render(ctx);
                ctx.restore();
            });
            console.log(ps);
            ctx.stroke();
            // backCanvasCtx.fillStyle = '#f00';
            ctx.restore();
        };
        return _this;
    }
    return TextShape;
}(Shape_1.Shape));
exports.TextShape = TextShape;
//# sourceMappingURL=TextShape.js.map